import * as ambassadorWixCalendarV3ScheduleTimeFrame from './calendar-v3-schedule-time-frame-schedule-time-frames.http.js';
import * as ambassadorWixCalendarV3ScheduleTimeFrameTypes from './calendar-v3-schedule-time-frame-schedule-time-frames.types.js';
import * as ambassadorWixCalendarV3ScheduleTimeFrameUniversalTypes from './calendar-v3-schedule-time-frame-schedule-time-frames.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getScheduleTimeFrame(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixCalendarV3ScheduleTimeFrameUniversalTypes.GetScheduleTimeFrameRequest,
  ambassadorWixCalendarV3ScheduleTimeFrameTypes.GetScheduleTimeFrameRequest,
  ambassadorWixCalendarV3ScheduleTimeFrameUniversalTypes.GetScheduleTimeFrameResponse,
  ambassadorWixCalendarV3ScheduleTimeFrameTypes.GetScheduleTimeFrameResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixCalendarV3ScheduleTimeFrame.getScheduleTimeFrame(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/schedules/timeframe/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listScheduleTimeFrames(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixCalendarV3ScheduleTimeFrameUniversalTypes.ListScheduleTimeFramesRequest,
  ambassadorWixCalendarV3ScheduleTimeFrameTypes.ListScheduleTimeFramesRequest,
  ambassadorWixCalendarV3ScheduleTimeFrameUniversalTypes.ListScheduleTimeFramesResponse,
  ambassadorWixCalendarV3ScheduleTimeFrameTypes.ListScheduleTimeFramesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCalendarV3ScheduleTimeFrame.listScheduleTimeFrames(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/schedules/timeframe',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ScheduleTimeFrame as ScheduleTimeFrameOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  ZonedDate as ZonedDateOriginal,
  GetScheduleTimeFrameRequest as GetScheduleTimeFrameRequestOriginal,
  GetScheduleTimeFrameResponse as GetScheduleTimeFrameResponseOriginal,
  ListScheduleTimeFramesRequest as ListScheduleTimeFramesRequestOriginal,
  ListScheduleTimeFramesResponse as ListScheduleTimeFramesResponseOriginal,
  SitePropertiesNotification as SitePropertiesNotificationOriginal,
  SitePropertiesEvent as SitePropertiesEventOriginal,
  Properties as PropertiesOriginal,
  Categories as CategoriesOriginal,
  Locale as LocaleOriginal,
  Address as AddressOriginal,
  AddressHint as AddressHintOriginal,
  PlacementType as PlacementTypeOriginal,
  PlacementTypeWithLiterals as PlacementTypeWithLiteralsOriginal,
  GeoCoordinates as GeoCoordinatesOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  ConsentPolicy as ConsentPolicyOriginal,
  Translation as TranslationOriginal,
  ChangeContext as ChangeContextOriginal,
  ChangeContextPayloadOneOf as ChangeContextPayloadOneOfOriginal,
  PropertiesChange as PropertiesChangeOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCloned as SiteClonedOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './calendar-v3-schedule-time-frame-schedule-time-frames.types.js';
